import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  dialogRef!: MatDialogRef<ConfirmDialogComponent>;

  constructor(
    private dialog: MatDialog
  ) { }

  open(mensaje: string){
    this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
      // width: '250px',
      data: mensaje,
    });
  }

  confirmed(): Observable<any> {
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
      return res;
    }))
    // .subscribe((result) => {
    //   // console.log(`Dialog result: ${result}`);
    //   if(result){
    //     // this.submitForm();
    //   }
    // });
  }
}
